import axiosInstance from "@/utils/axiosInstance";

const baseUrl = `api/admin/tags`;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  addTagForCategory({ commit }, payload: {
    tag: object,
    categoryId: number,
  }) {
    return axiosInstance.post(baseUrl, {
      tagParam: payload.tag,
      categoryId: payload.categoryId,
    }).then((data) => data.data);
  },
};

export default {
  namespaced: true, state, getters, actions, mutations,
};
